import { Controller } from "@hotwired/stimulus"

// Toggles between video still (with overlay) and Vimeo player. On "Watch" click:
// hides the preview, shows the iframe, adds autoplay to src and starts playback.
export default class extends Controller {
  static targets = ["preview", "player", "iframe"]

  connect() {
    this.played = false
  }

  play(event) {
    event.preventDefault()
    if (this.played) return
    this.played = true

    this.previewTarget.classList.add("is-hidden")
    this.playerTarget.classList.remove("is-hidden")

    const iframe = this.iframeTarget
    let src = iframe.getAttribute("src") || ""
    if (src && src.indexOf("autoplay=1") === -1) {
      iframe.setAttribute("src", src + (src.indexOf("?") === -1 ? "?" : "&") + "autoplay=1")
    }
  }
}
